import {
  SET_CART_ID,
  AUTO_APPLY_COUPON,
  RESET_AUTO_APPLY_COUPON,
} from "./types"

export type SetCartIdAction = ReturnType<typeof setCartId>
export const setCartId = (cartId: string | undefined) => ({
  type: SET_CART_ID,
  payload: cartId,
})

export type AutoApplyCouponAction = ReturnType<typeof autoApplyCouponAction>
export const autoApplyCouponAction = (code: string) => ({
  type: AUTO_APPLY_COUPON,
  payload: code,
})

export type ResetAutoApplyCouponAction = ReturnType<
  typeof resetAutoApplyCouponAction
>
export const resetAutoApplyCouponAction = () => ({
  type: RESET_AUTO_APPLY_COUPON,
})
